<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section">
        <div class="success-checkIn">
          <span>
            <v-icon
              color="#2E7D32"
              size="80"
            >
              mdi-check-circle-outline</v-icon>
          </span>
          <h1 class="header-style">
            Success
          </h1>
          <h2 class="header2-style">
            Cost Shifted Successfully
          </h2>
          <v-btn
            style="width: 40%; height: 40px"
            color="#37474F"
            class="mt-4 btn-style"
            elevation="0"
            @click="goToHome()"
          >
            Home
          </v-btn>
          <br>
          <centre-spinner
            :loading="loading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import moment from 'moment';
  export default {
      name: 'CheckInSuccessPage',
      components: {
          'centre-spinner': spinner,
      },
      filters: {
          convertToLocal (stringDatetime) {
              return moment(stringDatetime).local().format('Do MMMM YYYY, hh:mm A');
          },
      },
      mixins: [global],
      data () {
          return {
              loading: false,
              hours: null,
              minutes: null,
              seconds: null,
              checkInTime: null,
          };
      },
      computed: {
          locationName () {
              return this.$store.getters['swiftuser/getLocationName'];
          },
      },
      mounted () {
          this.loading = true;
          setTimeout(() => {
              this.loading = false;
          }, 2000);
      },
      methods: {
          checkOut () {
              this.loading = true;
              setTimeout(() => {
                  this.loading = false;

                  this.$router.push({ name: 'HomePage' });
              }, 2000);
          },
          home () {
              this.loading = true;
              setTimeout(() => {
                  this.loading = false;
                  this.$router.push({ name: 'HomePage' });
              }, 2000);
          },
          goToHome () {
              this.$router.push({ name: 'HomePage' });
          },
      },
  };
  </script>
  <style scoped>
  .success-checkIn{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
  }
  .checkin-timer{
      color: #ff3700;
      font-weight: bold;
  }
  #timer-text{
      font-weight: bold;
  }
  #success-message{
      font-size: 42px;
  }
  </style>
